export default "__VITE_ASSET__DTek9XHq__"